import { isLocalParticipantModerator, isParticipantModerator } from "../base/participants/functions";
const getState = (state) => state['features/raisehand-moderation'];
export const isEnableBanAllRaisehand = (state) => getState(state)?.enabled;
export const isLocalParticipantCanRaisehand = (state) => {
    if (isLocalParticipantModerator(state)) {
        return true;
    }
    const { canRaisehand } = getState(state);
    if (canRaisehand !== undefined) {
        return canRaisehand;
    }
    return !isEnableBanAllRaisehand(state);
};
export const isParticipantApprovedRaisehand = (participantId, state) => getState(state)?.whitelist[participantId];
export const isParticipantRejectedRaisehand = (participantId, state) => getState(state)?.blacklist[participantId];
export function isBannedRaisehand(participant, state) {
    if (participant.local) {
        return !isLocalParticipantCanRaisehand(state);
    }
    // Moderators cannot be banned from raising hand
    if (isParticipantModerator(participant)) {
        return false;
    }
    if (isEnableBanAllRaisehand(state)) {
        return !isParticipantApprovedRaisehand(participant.id, state);
    }
    return Boolean(isParticipantRejectedRaisehand(participant.id, state));
}
export function getCascadeRaisedHandQueue(state) {
    return getState(state)?.cascadeRaisedHandsQueue;
}
export function countCascadeRaiseHands(state, roomId = undefined) {
    let queue;
    if (!roomId)
        queue = getState(state)?.cascadeRaisedHandsQueue;
    else
        queue = getState(state)?.cascadeRaisedHandsQueue.filter(el => el.originRoomId === roomId);
    return queue.reduce((count, el) => el.count + count, 0);
}
